module.exports = __webpack_public_path__ + "img/logistics.5b0cbf63.png";